@if (item.purchaseable) {
    @if (purchasingToken.length) {
        <div class="p-0">
            <div class="p-0 spinner-border">
            </div>
        </div>
        } @else {

        <button class="btn btn-outline-bankruptcydata" (click)="purchaseDocument()">Buy</button>

        }

} @else {
    @if (item.documents.length) {
    <ul class="list-unstyled">
        @for (document of item.documents; track document.docs_id) {
        <li>
            <a (click)="displayPDF(document.our_path)" class="pdf-link"><ng-container *ngTemplateOutlet="documentDesc; context: { $implicit: document.description }"></ng-container> </a>
        </li>
        }
    </ul>
    }
}
<adobe-pdf-viewer></adobe-pdf-viewer>

<ng-template #documentDesc let-desc>
    @if (desc.includes('Image')) {
    Main
    } @else {
    {{ desc }}
    }
</ng-template>


<app-input-dialog #purchasePDF title="Purchase Document From Pacer">
    <input-dialog-step button="">
        <form #purchasePDFForm (ngSubmit)="checkPacerLogin()">
            <div class="row py-2">
                <div class="col">
                    <p>To complete the purchase we need your PACER credentials. We do not store your PACER credentials.</p>
                    @if (pacerCredentialsWrong) {
                    <div class="alert alert-danger" role="alert">
                        Username and/or password incorrrect
                    </div>
                    }
                    <div class="form-floating mb-4">
                        <input type="text" class="form-control" id="pacerUsername" name="pacerUsername" required [class.is-invalid]="pacerUsernameRequired" [(ngModel)]="pacerUsername" (focus)="$any($event.target).select()" ngbAutofocus>
                        <label class="form-label" for="pacerUsername">Pacer Username</label>
                    </div>
                    <div class="invalid-feedback">
                        Username required
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-auto">
                    <div class="form-floating mb-4">
                        <input type="password" class="form-control" id="pacerPassword" name="pacerPassword" required [class.is-invalid]="pacerPasswordRequired" [(ngModel)]="pacerPassword" (focus)="$any($event.target).select()">
                        <label class="form-label" for="pacerPassword">Pacer Password</label>
                    </div>
                    <div class="invalid-feedback">
                        Password required
                    </div>
                </div>
            </div>
            <div class="row mt-3">
                <div class="col-auto">
                    @if (pacerLoginButtonEnabled) {
                    <button type="submit" class="btn btn-outline-bankruptcydata btn-block mb-3">Submit</button>
                    } @else {
                    <button class="btn btn-outline-bankruptcydata btn-block mb-3" type="button" disabled>
                        <span class="spinner-border spinner-border-sm" role="status"></span>
                    </button>

                    }
                </div>
            </div>
        </form>
    </input-dialog-step>
</app-input-dialog>
